// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {isFeatureEnabled} from '@github-ui/feature-flags'

export const COPY = {
  heading: {
    title: 'The AI assistant that builds with you',
    description: 'Generate code, manage tasks, and explore your projects all in one place with GitHub Copilot',
  },
  ideList: {
    title: 'Try Copilot on your favorite platform',
  },
} as const

export const getProductAnnouncementId = () => {
  if (isFeatureEnabled('hyperspace_nudges_universe25')) return 'universe25'

  return ''
}
